import MuiTypography from '@mui/material/Typography';
import { Status } from './Data.conf';
import _ from 'lodash';
import CalendarIcon from '@mui/icons-material/CalendarMonth';
import PersonIcon from '@mui/icons-material/Person';
import { Box, Chip, Grid, Stack, Tooltip } from '@mui/material';
import { Fragment } from 'react';
import dayjs from 'dayjs';
import RectangleChip from '../../../components/common/RectangleChip.component';
import TableCellEdit from '../../../components/table/components/TableCellEdit.component';
import booking from '..';
import { API } from '../api';
import TextField from '../../../components/form/components/TextField.component';
import SailingIcon from '@mui/icons-material/Sailing';
import utc from 'dayjs/plugin/utc';
import * as yup from 'yup';

dayjs.extend(utc);

export const ListConf = {
  initialState: {
    pagination: {
      page: 1,
      pageSize: 100,
    },
    sort: {
      by: 'createdAt',
      direction: 'desc',
    },
  },
  rowsPerPageOptions: [25, 50, 100],
  columns: [
    {
      id: 'attributes.booking_status',
      key: 'booking_status',
      sort_key: 'booking_status',
      sortable: true,
      label: 'STATUS',
      width: 180,
    },
    {
      id: 'attributes.yacht_name_id',
      key: 'yacht_name',
      sort_key: 'id_yacht.yacht_name',
      sortable: true,
      label: 'NAME',
    },
    {
      id: 'attributes.note2_id',
      key: 'note2_id',
      sort_key: 'note2',
      sortable: true,
      label: 'NOTE 2',
      checkbox: true,
    },
    {
      id: 'attributes.id_marina.data.attributes.marina',
      key: 'place',
      sort_key: 'id_marina.marina',
      sortable: true,
      label: 'MARINA',
    },
    {
      id: 'attributes.check_in_date',
      key: 'check_in_date',
      sort_key: 'check_in_date',
      sortable: true,
      label: 'CHECK IN',
      width: 160,
      maxWidth: 160,
    },
    {
      id: 'attributes.check_out_date',
      key: 'check_out_date',
      sort_key: 'check_out_date',
      sortable: true,
      label: 'CHECK OUT',
      width: 160,
      maxWidth: 160,
    },
    {
      id: 'attributes.booking_days',
      key: 'booking_days',
      sort_key: 'booking_days',
      sortable: true,
      label: 'NIGHTS',
      align: 'center',
      width: 100,
      maxWidth: 100,
    },
    {
      id: 'attributes.id_yacht.data.attributes.id_attendance.data[0].attributes.id_agent_NA.data.attributes.id_users_permissions_user.data.attributes',
      key: 'name',
      sort_key:
        'id_yacht.id_attendance.id_agent_NA.id_users_permissions_user.name',
      sortable: true,
      label: 'NA AGENCY',
      width: 100,
    },
    {
      id: 'attributes.id_yacht.data.attributes.id_attendance.data[0].attributes.id_user_provision.data.attributes.id_users_permissions_user.data.attributes',
      key: 'name',
      sort_key:
        'id_yacht.id_attendance.id_user_provision.id_users_permissions_user.name',
      sortable: true,
      label: 'SALES AGENT',
    },
    {
      id: 'attributes.incoming',
      key: 'incoming',
      sort_key: null,
      sortable: false,
      label: '',
      width: 10,
    },
  ],
  render: {
    formatHead: (key, value) => {
      switch (key) {
        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold', color: 'white' }}
            >
              {value}
            </MuiTypography>
          );
      }
    },
    formatValue: (key, value, onClick) => {
      switch (key) {
        case 'name':
          return (
            <Box display='flex' alignItems='center' onClick={onClick}>
              {value ? (
                <Fragment>
                  <PersonIcon color='action' fontSize='small' />
                  <MuiTypography sx={{ ml: 1 }} variant='body1'>
                    {`${value?.name} ${value?.surname}`}
                  </MuiTypography>
                </Fragment>
              ) : (
                '-'
              )}
            </Box>
          );
        case 'place':
          return (
            <MuiTypography variant='body1' onClick={onClick}>
              {value ? value : '-'}
            </MuiTypography>
          );
        case 'check_in_date':
        case 'check_out_date':
          return (
            <Box display='flex' alignItems='center' onClick={onClick}>
              {value ? (
                <Fragment>
                  <CalendarIcon color='action' />
                  <MuiTypography sx={{ ml: 1 }} variant='body1'>
                    {dayjs(value).format('DD-MM-YYYY HH:mm')}
                  </MuiTypography>
                </Fragment>
              ) : (
                '-'
              )}
            </Box>
          );
        case 'booking_status':
          const color = _.find(
            Status,
            (item) => item.label.toUpperCase() === value.toUpperCase()
          );
          return (
            <Box onClick={onClick}>
              {value ? (
                <RectangleChip
                  value={value}
                  backgroundColor={color?.hex}
                  color={'#fff'}
                  width='150px'
                />
              ) : (
                '-'
              )}
            </Box>
          );
        case 'note2_id':
          return (
            <TableCellEdit
              module={{
                ...booking,
                query: {
                  ...booking.query,
                  edit: { settings: API.updateFromList },
                },
              }}
              defaultValues={{ note2: value?.note2 }}
              value={value}
              name={'note2'}
              schema={yup.object({
                note2: yup
                  .string()
                  .max(255, 'You can enter a maximum of 255 characters')
                  .nullable(),
              })}
              form={
                <Grid item xs={12} sm={12}>
                  <TextField
                    id='note2'
                    name='note2'
                    label='Notes'
                    type='text'
                    multiline
                    rows={5}
                  />
                </Grid>
              }
            >
              <MuiTypography variant='body1'>
                {value?.note2 || '-'}
              </MuiTypography>
            </TableCellEdit>
          );
        case 'incoming':
          return value ? (
            <Box
              onClick={onClick}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                animation: 'blinker 1.5s linear infinite',
                '@keyframes blinker': {
                  '50%': { opacity: 0 },
                },
              }}
            >
              <SailingIcon sx={{ color: '#005488' }} />
            </Box>
          ) : (
            ''
          );

        case 'yacht_name': {
          const mexalCode = value?.mexal_code || '-';
          const mexalResearchName = value?.mexal_research_name || '-';
          const mexalTooltip = [mexalCode, mexalResearchName]
            .filter((item) => item && item !== '-')
            .join(' - ');

          return (
            <Tooltip title={mexalTooltip || ''}>
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                spacing={1}
              >
                <Stack direction={'column'} spacing={0.5}>
                  <MuiTypography
                    sx={{ fontWeight: 'bold', height: 1 }}
                    variant='body1'
                    onClick={onClick}
                  >
                    {value?.yacht_name || '-'}
                  </MuiTypography>
                  {value?.provenence && (
                    <MuiTypography
                      variant='caption'
                      color='text.secondary'
                      onClick={onClick}
                    >
                      {value?.provenence}
                    </MuiTypography>
                  )}
                </Stack>
                <Chip label={`#${value?.id || '-'}`} size='small' />
              </Stack>
            </Tooltip>
          );
        }

        default:
          return (
            <MuiTypography
              variant='body1'
              sx={{ fontWeight: 'bold' }}
              onClick={onClick}
            >
              {value !== null || value !== undefined ? value : '-'}
            </MuiTypography>
          );
      }
    },
  },
};
